module.exports = __webpack_public_path__ + "img/BuyAbilityImg3.f51b3f34.png";